export default __webpack_public_path__ + "static/media/Diodrum-Semibold.e6736f5e.otf";